export { default } from "./message";
export { getLinkHref, needMessageLink } from "./messageLink";
